import { render, staticRenderFns } from "./team.vue?vue&type=template&id=099f13ca&scoped=true"
import script from "./team.vue?vue&type=script&lang=js"
export * from "./team.vue?vue&type=script&lang=js"
import style0 from "./team.vue?vue&type=style&index=0&id=099f13ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099f13ca",
  null
  
)

export default component.exports